module.exports = __webpack_public_path__ + "static/media/img3-360-360.725a212c.png";